import React, {Component} from 'react';
import ReactDOM from 'react-dom'
import Weibo from './Weibo'
import './Main.css'
import dataWeibo from '../data/tqq_weibo'


export default class extends Component {
    constructor() {
        super();
        this.state = this.loadState({
            sortRule: 1,
            weiboIndex: 0,
            numInPage: 10
        });
    }

    changePage(isNext=true) {
        let newIndex = this.state.weiboIndex;
        switch (this.state.sortRule) {
            case 1:  // 从新到旧
                if (isNext)
                    newIndex += this.state.numInPage;
                else
                    newIndex -= this.state.numInPage;
                break;
            case 2:  // 从旧到新
                if(isNext)
                    newIndex -= this.state.numInPage;
                else
                    newIndex += this.state.numInPage;
                break;
            default:  //随机
                this.forceUpdate();
        }

        this.setState({weiboIndex: newIndex});
        this.saveState();

        let $ = global.jQuery;
        $('html,body').animate({
            scrollTop: $( ReactDOM.findDOMNode(this) ).offset().top - 20
        }, 500);
        $( this.refs.content ).hide().fadeIn(1400);
    }


    changeSort(changeTo=1) {
        let newIndex = (changeTo===1) ? 0 : dataWeibo.length-1;
        this.setState({
            weiboIndex: newIndex,
            sortRule: changeTo
        });
        this.saveState();

        global.jQuery( this.refs.content ).hide().fadeIn('normal');
    }


    saveState() {
        localStorage['Moshel_tqq'] = JSON.stringify( this.state );
    }
    loadState(state={}) {
        try {
            let savedS = JSON.parse( localStorage['Moshel_tqq'] );
            state = Object.assign(state, savedS);
        }
        catch(e) {}
        return state;
    }


    render() {
        return (
            <div className="container">
                <div className="row justify-content-end">
                    <div className="col-lg-4 col-md-6 col-sm-8">
                        <div className="btn-group" role="group">
                            <button type="button" className={`btn btn-secondary ${this.state.sortRule===1?'active':''} `}
                                    onClick={this.changeSort.bind(this, 1)} >
                                    回首往事</button>
                            <button type="button" className={`btn btn-secondary ${this.state.sortRule===2?'active':''} `}
                                    onClick={this.changeSort.bind(this, 2)} >
                                    重走历史</button>
                            <button type="button" className={`btn btn-secondary ${this.state.sortRule===3?'active':''} `}
                                    onClick={this.changeSort.bind(this, 3)} >
                                    错乱时光</button>
                        </div>
                    </div>
                    <div className="col-lg-1"/>
                </div>

                <div className="row">
                    <div className="col-lg-8 col-md-10 mx-auto" ref="content">
                        {this.render_get_weibo()}

                        {this.render_pager()}
                    </div>
                </div>
            </div>
        )
    }

    render_get_weibo() {
        let {sortRule,weiboIndex,numInPage} = this.state;

        let ret = [],
            needIndex = [];

        // build needIndex Array
        switch(sortRule) {
            case 1:  //从新到旧
                for(let i=0; i<numInPage; i++) {
                    while(weiboIndex < dataWeibo.length && dataWeibo[weiboIndex].user !== 'Moshel')
                        weiboIndex++;
                    if(weiboIndex >= dataWeibo.length) break;
                    needIndex.push(weiboIndex);
                    weiboIndex++;
                }
                break;
            case 2:  // 从旧至新
                for(let i=0; i<numInPage; i++) {
                    while(weiboIndex >=0 && dataWeibo[weiboIndex].user !== 'Moshel')
                        weiboIndex--;
                    if(weiboIndex < 0) break;
                    needIndex.push(weiboIndex);
                    weiboIndex--;
                }
                break;
            default:  //随机
                for(let i=0; i<numInPage; i++) {
                    let rndIndex = 0;
                    do {
                        rndIndex = Math.floor( dataWeibo.length * Math.random() )
                    } while(dataWeibo[rndIndex].user !== 'Moshel' || needIndex.indexOf(rndIndex)>=0 );
                    needIndex.push( rndIndex );
                }
                break;
        }

        // build ret Weibo
        for(let i of needIndex) {
            ret.push(<Weibo index={i} key={i} />)
        }

        return ret;
    }

    render_pager() {
        let {sortRule,weiboIndex,numInPage} = this.state;

        switch(sortRule) {
            case 1:  // 顺序
                return (
                    <div className="clearfix pager">
                        { weiboIndex+numInPage<dataWeibo.length ?
                            <a className="btn btn-primary float-right" onClick={this.changePage.bind(this, true)} >
                            下一页 <i className="fa fa-chevron-right"/></a>
                            : null }
                        { weiboIndex>0 ?
                            <a className="btn btn-primary float-left" onClick={this.changePage.bind(this, false)} >
                            <i className="fa fa-chevron-left"/> 上一页</a>
                            : null }
                    </div>
                );
            case 2:  //逆序
                return (
                    <div className="clearfix pager">
                        { weiboIndex-numInPage>=0 ?
                            <a className="btn btn-primary float-right" onClick={this.changePage.bind(this, true)} >
                                下一页 <i className="fa fa-chevron-right"/></a>
                            : null }
                        { weiboIndex<dataWeibo.length-1 ?
                            <a className="btn btn-primary float-left" onClick={this.changePage.bind(this, false)} >
                                <i className="fa fa-chevron-left"/> 上一页</a>
                            : null }
                    </div>
                );
            default:  // random
                return (
                    <div className="clearfix pager">
                        <a className="btn btn-primary float-right" onClick={this.changePage.bind(this)} >
                            <i className="fa fa-refresh"/> 刷新 </a>
                    </div>
                );
        }
    }

}



// WEBPACK FOOTER //
// ./src/main-content/Main.js